<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="600px" persistent fluid scrollable content-class="round-2xl")
  v-card(height="90vh")
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Patient
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-skeleton-loader(v-if="isLoading" type="article")
      div(v-else)
        .text-md.font-semibold.neutral700--text Patient details
        v-card.pa-4.round-lg.mt-2(outlined)
          .d-flex
            div(style="width: 70px;")
              v-responsive(:aspect-ratio="7/10")
                v-card.fill-height.round-xl(v-if="resizeImageFileUrl" flat)
                  v-img(:src="resizeImageFileUrl" height="100%" width="100%")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")
                v-card.neutral300.fill-height.round-xl(v-else flat)
                  .d-flex.align-center.justify-center.fill-height
                    v-icon(size="45") $yzi-user-03
            .ml-6
              .text-md.font-semibold.neutral700--text {{ patient.name }}
              .text-xs.font-medium.neutral700--text.mt-1 {{ patient.ic }}
              .text-xs.font-medium.neutral700--text {{ getAge(patient.dob) }} years old
              .text-xs.font-medium.neutral700--text {{ genders.find(f => f.value === patient.gender) ? genders.find(f => f.value === patient.gender).text : '-' }}
          v-row.mt-3(dense)
            v-col(cols="6")
              .text-xs.neutral500--text {{ $t('email') }}
              .text-sm.neutral700--text.mt-1 {{ patient.email || '-' }}
            v-col(cols="6")
              .text-xs.neutral500--text {{ $t('phone_number') }}
              .text-sm.neutral700--text.mt-1 {{ patient.phone ? `+${patient.phone}` : '-' }}
            v-col.pt-3
              .text-xs.neutral500--text {{ $t('address') }}
              .text-sm.neutral700--text.mt-1 {{ emptyAddress ? '-' : getAddressInString(address) }}

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed @click="closeDialog") {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    id: {
      default: null
    },
  },
  components: {},
  data: () => ({
    isLoading: false,
    patient: {},
    address: {},
    genders: [
      { text: 'Male', value: 'male' },
      { text: 'Female', value: 'female' },
    ],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    emptyAddress () {
      if (Object.keys(this.address).length === 0) {
        return true
      } else if (Object.values(this.address).every(val => !val)) {
        return true
      }
      return false
    },
  },
  mounted () {
    this.fetchPatient()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatient () {
      this.isLoading = true
      this.$axios.get(`/clinics/${this.company.slug}/patients/${this.id}`)
        .then(resp => {
          let data = resp.data
          if (data.address) {
            this.address = JSON.parse(JSON.stringify(data.address))
          }
          delete data.address
          this.patient = data
          this.resizeImageFileUrl = data.profile_image?.file ?? ''
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.showDialog = false
    },
    getAge (date) {
      var today = new Date();
      var birthDate = new Date(date);
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    getAddressInString (addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
  }
}
</script>
